var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrowDarkViolet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95962 0.570711C8.99867 0.531658 9.06199 0.531658 9.10104 0.570711L12.9899 4.45962C13.029 4.49867 13.029 4.56199 12.99 4.60104L9.10104 8.48995C9.06199 8.529 8.99867 8.529 8.95962 8.48995L8.04038 7.57071C8.00133 7.53166 8.00133 7.46834 8.04038 7.42929L10.0186 5.45104C10.0816 5.38804 10.037 5.28033 9.94792 5.28033H0.1C0.0447715 5.28033 0 5.23556 0 5.18033V3.88033C0 3.8251 0.0447718 3.78033 0.1 3.78033H9.94792C10.037 3.78033 10.0816 3.67262 10.0186 3.60962L8.04038 1.63137C8.00133 1.59232 8.00133 1.529 8.04038 1.48995L8.95962 0.570711Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowDarkViolet);
export default __webpack_public_path__ + "static/media/right_arrow_dark_violet.0d49330a.svg";
export { ForwardRef as ReactComponent };